module.exports = __webpack_public_path__ + "static/philips-d1282f64fd0f6315b1d6b01d7798d4f7.jpg";